import FinancialHeader from './financialHeader/financialHeader';
import DownloadFile from './downloadFile/downloadFile';

export default angular.module('eventix.dashboard.financials.reporting.common', [FinancialHeader, DownloadFile])
    .name;